import * as React from 'react';
import { AppMessageBarProps } from "./AppMessageBar.props";
import { MessageBar, Label, concatStyleSets } from 'office-ui-fabric-react';
import { AppLayoutSettings } from "../../common/styles/common.styles";
import { getCloseIconStyle, getCloseIconStyleInLightMode } from './AppMessageBar.styles';

/**
 * Teaching Bubble
 * @param props Teaching bubble component properties
 */
export const AppMessageBar: React.FunctionComponent<AppMessageBarProps> = (props: AppMessageBarProps): JSX.Element => {

  // The prefers-contrast CSS media feature is used to detect whether the user has requested the web content to be
  // presented with a lower or higher contrast. More Info :- https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
  const [isDarkContrastEnabled, setDarkContrastEnabledFlag] = React.useState(
    window.matchMedia("(prefers-contrast: more)").matches
  )

  React.useEffect(() => {
    window
    .matchMedia("(prefers-contrast: more)")
    .addEventListener('change', e => setDarkContrastEnabledFlag( e.matches ));
  }, []);


  return (
    <div style={ props.containerStyle }>
      { isDarkContrastEnabled &&
        (<MessageBar
          styles={ props.styles }
          messageBarType={ props.messageBarType }
          dismissButtonAriaLabel={ props.dismissButtonAriaLabel }
          onDismiss={ props.onDismiss }
          isMultiline={ true }
          dismissIconProps={ {
            iconName: 'ChromeClose', style: getCloseIconStyle()
          } }
        >
          <Label styles={ concatStyleSets(AppLayoutSettings.AppCommonStyles.getBoldLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().darkLabelColor), props.labelStyles) }>
            { props.headerText }
          </Label>
          <Label styles={ concatStyleSets(AppLayoutSettings.AppCommonStyles.getRegularLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().mediumLabelColor), props.labelStyles) }>
            { props.children }
          </Label>
        </MessageBar>) }
      { !isDarkContrastEnabled &&
        (<MessageBar
          styles={ props.styles }
          messageBarType={ props.messageBarType }
          dismissButtonAriaLabel={ props.dismissButtonAriaLabel }
          onDismiss={ props.onDismiss }
          isMultiline={ true }
          dismissIconProps={ {
            iconName: 'ChromeClose', style: getCloseIconStyleInLightMode()
          } }
        >
          <Label styles={ concatStyleSets(AppLayoutSettings.AppCommonStyles.getBoldLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().darkLabelColor), props.labelStyles) }>
            { props.headerText }
          </Label>
          <Label styles={ concatStyleSets(AppLayoutSettings.AppCommonStyles.getRegularLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().mediumLabelColor), props.labelStyles) }>
            { props.children }
          </Label>
        </MessageBar>) }
    </div>
        );
}